import apiClient from './apiClient';

export const getEducationalDisclaimerSections = async () => {
  const { data } = await apiClient.get('/api/educational-disclaimer');
  return Array.isArray(data) ? data : [];
};

export const saveEducationalDisclaimerSections = async (sections) => {
  const { data } = await apiClient.put(
    '/api/educational-disclaimer',
    sections || []
  );
  return Array.isArray(data) ? data : [];
};

